import React from 'react';

export const SyncedBlockLoadingState = () => {
	return <div>Loading...</div>;
};
